import React from 'react';
import { Link } from 'react-router-dom';


// image
import Ab from '../../images/about/dfit-home.webp'
// import Ab from '../../images/about/ab.jpg'
import Abd1 from '../../images/about/1.png'
import Abd2 from '../../images/about/4.png'
import Abd3 from '../../images/about/5.png'
import Abd4 from '../../images/about/3.png'
import sine from '../../images/about/2.png'

const about = (props) => {
    const ClickHandler = () => {
        window.scrollTo(10, 0);
    }
    return (
        <section className={"" + props.hclass}>
            <div className="container-fluid">
                <div className="row align-items-center">
                    <div className="col-lg-4 col-md-12 col-12">
                        <div className="orico-about-wrap">
                            <div className="orico-about-img">
                                <div className="mask">
                                    <img src={Ab} alt=""/>
                                </div>
                                <div className="orico-ab-logo">
                                    <img src={Abd1} alt=""/>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="col-lg-8 col-md-12 col-12">
                        <div className="orico-about-text-wrap">
                            <div className="orico-about-text">
                                <span>“<span>À Propos de nous</span>”</span>
                                <h2>D-FIT, centre de nutrition, santé et sport</h2>
                                <p>Créé en 2018 par Ingrid NGOUNÉ, Diet and Fitness (D-FIT) livre des repas 100% diététiques à base de produits du terroir. Première chaine de restauration à intégrer le réseau de distribution TOTAL ÉNERGIES Cameroun, mettant à disposition du public un restaurant à même d’accueillir des visiteurs, une supérette foisonnante de farines locales, laitages et d’un cabinet chapeauté par une équipe d’experts. </p>
                                <p>L’enseigne a entamé le projet de construction de son usine à Douala, capitale économique du Cameroun, preuve de leur maîtrise des désirs des populations en quête d’un mode de vie à impact positif.</p>
                                {/* <ul>
                                    <li><i><img src={Abd2} alt=""/></i> It has survived not only
                                        five centuries the leap into.</li>
                                    <li><i><img src={Abd3} alt=""/></i> It has survived not only
                                        five centuries the leap into.</li>
                                </ul> */}
                                <Link onClick={ClickHandler} className="theme-btn-s2" to="/about">Prendre Contact</Link>
                            </div>
                            <div className="ab-onion-shape"><img src={Abd4} alt=""/></div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="ab-shape"><img src={sine} alt=""/></div>
        </section>
    );
};

export default about;